import { render } from "./BienBanKiemNghiemPrintModal.vue?vue&type=template&id=1fb9711e&ts=true"
import script from "./BienBanKiemNghiemPrintModal.vue?vue&type=script&lang=ts"
export * from "./BienBanKiemNghiemPrintModal.vue?vue&type=script&lang=ts"

import "./BienBanKiemNghiemPrintModal.vue?vue&type=style&index=0&id=1fb9711e&lang=scss"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__